{
    "Title": "Meeting",
    "Meeting_Name": "Meeting Name: **{}**",
    "Statistic_Meeting_type": "Meeting Type",
    "Statistic_Total_Participants": "Total Participants",
    "Statistic_Start_Time": "Start Time",
    "Statistic_Total_Meeting_Duration": "Total Meeting Duration",
    "Table_Header_Name": "Name",
    "Table_Header_Type": "Type",
    "Table_Header_Entry_Time": "Entry Time",
    "Table_Header_Leave_Time": "Leave Time",
    "Table_Header_Duration": "Duration In Meeting",
    "Statistic_Search": "Search",
    "MeetingID": "Copy Meeting ID",
    "Copied": "Copied!",
    "NAME": "CallDetailsMeeting"
}